import { render, staticRenderFns } from "./ProjectDependencies.vue?vue&type=template&id=40a4792a&scoped=true&"
import script from "./ProjectDependencies.vue?vue&type=script&lang=js&"
export * from "./ProjectDependencies.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDependencies.vue?vue&type=style&index=0&id=40a4792a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4792a",
  null
  
)

export default component.exports